export const PERMISSION_RESOURCE_CODES = {
  overview: 'exit-overview',
  opportunity: 'exit-opportunity',
  project: 'exit-project',
  transaction: 'exit-transaction',
  dashboard: 'exit-dashboard',
  settings: 'exit-settings',
} as const;

export const PERMISSION_ACTION_CODES = {
  overview: { view: 'view' },
  opportunity: {
    view: 'view',
    edit: 'edit',
    approve: 'approve',
    manage: 'manage',
  },
  project: {
    view: 'view',
    edit: 'edit',
    approve: 'approve',
    manage: 'manage',
  },
  transaction: {
    view: 'view',
    edit: 'edit',
    approve: 'approve',
    manage: 'manage',
  },
  dashboard: { view: 'view' },
  settings: { view: 'view', manage: 'manage' },
} as const;

export const PERMISSION_VIEW_CODES = {
  overview:
    `${PERMISSION_RESOURCE_CODES.overview}:${PERMISSION_ACTION_CODES.overview.view}`,
  opportunity:
    `${PERMISSION_RESOURCE_CODES.opportunity}:${PERMISSION_ACTION_CODES.opportunity.view}`,
  project:
    `${PERMISSION_RESOURCE_CODES.project}:${PERMISSION_ACTION_CODES.project.view}`,
  transaction:
    `${PERMISSION_RESOURCE_CODES.transaction}:${PERMISSION_ACTION_CODES.transaction.view}`,
  dashboard:
    `${PERMISSION_RESOURCE_CODES.dashboard}:${PERMISSION_ACTION_CODES.dashboard.view}`,
  settings:
    `${PERMISSION_RESOURCE_CODES.settings}:${PERMISSION_ACTION_CODES.settings.view}`,
} as const;

export const getPermissionAccessKey = (
  resource: keyof typeof PERMISSION_RESOURCE_CODES,
  action?: string,
) => {
  const code = PERMISSION_RESOURCE_CODES[resource];
  return action ? `${code}:${action}` : code;
};

export const hasPermissionAction = (
  access: Record<string, boolean | undefined>,
  resource: keyof typeof PERMISSION_RESOURCE_CODES,
  action: string,
) => {
  const resourceCode = PERMISSION_RESOURCE_CODES[resource];
  return Boolean(
    access[`${resourceCode}:${action}`] ??
      (action !== 'manage' && access[`${resourceCode}:manage`]) ??
      access[`${resourceCode}:*`],
  );
};
